module.exports = __webpack_public_path__ + "443722c3048e834ee3aab2ad86bb6901.woff";